module.exports = __webpack_public_path__ + "static/media/english_flag.4e7b25ff.svg";